/* eslint-disable import/prefer-default-export */
import BaseFeature from '@appblocks/codegeneration/BaseFeature';
import ProjectConfiguration from '@appblocks/codegeneration/ProjectConfiguration';
import {
    CodeBlock,
    BlockType,
    SettingType,
    Define,
    ValidationMessageType,
    ValidationMessage,
    SettingState,
    Setting,
    TibboDataType,
} from '@appblocks/codegeneration/types';
import BaseNode from '@appblocks/codegeneration/Nodes/BaseNode';
import NodePort from '@appblocks/codegeneration/Nodes/NodePort';
import NodeParameter from '@appblocks/codegeneration/Nodes/NodeParameter';
import Peripherals from '@appblocks/codegeneration/Peripherals';


export const getCodeBlocks = (feature: BaseFeature): CodeBlock[] => {
    const blocks = [];
    blocks.push({
        location: 'boot',
        blockType: BlockType.CODE,
        template: `
'ADC setup for ADC num ${feature.getSettingValue('PORT')}
adc.num=${feature.getSettingValue('NAME')}_CHANNEL
adc.enabled=YES
    `,
    });
    blocks.push({
        location: 'GLOBAL_CONSTS',
        blockType: BlockType.CODE,
        template: `
const ${feature.getSettingValue('NAME')}_CHANNEL=${feature.getSettingValue('PORT')}
        `,
    });
    return blocks;
};
